import Skeleton from '@wconcept/wconcept-ui-renewal/components/atoms/Skeleton';

import * as S from './style';

interface IProps {
  bgType?: 'white' | 'black' | string;
}

const PrdItemSkeleton = ({ bgType = 'white' }: IProps) => (
  <S.Box className="item" $bgType={bgType}>
    <Skeleton className="thum" />
    <Skeleton className="text text01" />
    <Skeleton className="text text02" />
  </S.Box>
);

export default PrdItemSkeleton;
